export const GUIDED_TOUR_STEPS = [
  {
    id: "welcome",
    scene: "welcome",
    title: "Conheça o neo-modelos em poucos passos",
    body: "Um tour pelos fluxos principais: modelos, IA, PDF, assinatura, elaboração livre, modelos personalizados e WhatsApp.",
  },
  {
    id: "library",
    scene: "library",
    title: "Escolha um modelo pronto",
    body: "Na Biblioteca de Modelos você encontra modelos do sistema por categoria — aqui destacamos uma Autorização para Venda de Imóvel.",
  },
  {
    id: "fill",
    scene: "fill",
    title: "Preencha com ajuda da IA",
    body: "Modelos complexos têm muitos campos (proprietário, cônjuge, intermediador, imóvel…). A NeoAi preenche a partir do seu texto.",
  },
  {
    id: "pdf",
    scene: "pdf",
    title: "Gere o PDF do documento",
    body: "Com os campos prontos, o sistema gera o PDF profissional para baixar, enviar ou assinar.",
  },
  {
    id: "sign",
    scene: "sign",
    title: "Posicione campos e envie para assinar",
    body: "No PDF completo (várias páginas) você posiciona assinaturas — proprietário, cônjuge e intermediador — e envia o link.",
  },
  {
    id: "dashboard",
    scene: "dashboard",
    title: "Acompanhe tudo no painel",
    body: "No início você vê status dos documentos: rascunho, PDF gerado, aguardando assinatura e concluídos.",
  },
  {
    id: "write-contract",
    scene: "write-contract",
    title: "Elabore qualquer documento com a NeoAi",
    body: "Você pode elaborar qualquer documento que quiser usando a Neo AI e o editor de texto com customização.",
  },
  {
    id: "create-template",
    scene: "create-template",
    title: "Traga ou crie seus modelos",
    body: "Importe PDF e DOCX, crie manualmente ou use a NeoAi para um modelo personalizado com placeholders para as suas necessidades.",
  },
  {
    id: "more",
    scene: "more",
    title: "Também pelo WhatsApp",
    body: "O Neo Bot elabora documentos a partir de um modelo, envia o PDF na conversa e dispara a assinatura — com detecção automática dos campos.",
  },
  {
    id: "close",
    scene: "close",
    title: "Pronto para usar de verdade?",
    body: "Crie sua conta gratuita e explore o sistema completo — preenchendo, gerando e assinando os seus documentos.",
  },
];
